export { default } from './PrivateLabelCTA';
export type {
  IPrismicPrivateLabelCTAPrimary,
  IPrismicPrivateLabelCTAItem,
} from './types';
